import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalendarScheduleComponent } from './calendar-schedule.component';
const routes: Routes = [ { path: '', component: CalendarScheduleComponent }];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CalendarScheduleRoutingModule { }
